import React, { useState, useEffect,useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Box, Button, Card, CardMedia, Typography, Grid, Snackbar, Alert, IconButton } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import Navbar from "./layout/Navbar";
import Footer from "./layout/Footer";
import HomepageContext from "./context/HomepageContext";

const ProductDetail = () => {
  
  const { handleAddToCart,successMessage,handleSnackbarClose,setSuccessMessage,product, setProduct,quantity,setQuantity } = useContext(HomepageContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { productId } = useParams();


  const [selectedImage, setSelectedImage] = useState(product?.ProdImage || "");
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' }); // or 'auto' instead of 'smooth'
  }, []);
  
  // Fetch product data on component mount
  useEffect(() => {
    let storedProduct = location.state || JSON.parse(sessionStorage.getItem("productData"));
  
    if (!storedProduct) {
      const storedProducts = JSON.parse(sessionStorage.getItem("allProducts")) || [];
      const foundProduct = storedProducts.find(p => p.ProdtID === parseInt(productId) || p.ProdtID === parseInt(productId));
  
      if (foundProduct) {
        storedProduct = foundProduct;
      } else {
        const productToAdd = JSON.parse(sessionStorage.getItem("productToAdd"));
        if (productToAdd && ( productToAdd.ProdtID === parseInt(productId))) {
          storedProduct = productToAdd;
        }
      }
    }
  
    if (storedProduct) {
      setProduct(storedProduct);
      setSelectedImage(storedProduct.ProdImage);
    } else {
      console.warn("Product not found after login!");
    }
  }, [productId, location.state]);
  

  // Handle cart addition after login redirect
  useEffect(() => {
    const productToAdd = JSON.parse(sessionStorage.getItem("productToAdd"));
    const user = sessionStorage.getItem("user");
    const redirectAfterLogin = sessionStorage.getItem("redirectAfterLogin");

    if (productToAdd && user && redirectAfterLogin) {
      let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
      const existingProduct = cart.find((item) => item.ProdtID === productToAdd.ProdtID);

      if (existingProduct) {
        existingProduct.quantity += productToAdd.quantity;
      } else {
        cart.push({ ...productToAdd, quantity: productToAdd.quantity });
      }

      sessionStorage.setItem("cart", JSON.stringify(cart));
      window.dispatchEvent(new Event("storage"));

      setSuccessMessage(true);
      sessionStorage.removeItem("productToAdd");
      sessionStorage.removeItem("redirectAfterLogin");
    }
  }, []); // Runs once on component mount

  // Existing handlers remain the same
  const handleQuantityChange = (newQuantity) => {
    if (newQuantity < 1 || newQuantity > product.ProdStock) return;
    setQuantity(newQuantity);
  };

 



  const handleBuyNow = () => {
    navigate("/checkout");
  };

  const isOutOfStock = product?.ProdStock === 0;


  return (
    <>
      <Navbar />
      <Box maxWidth="lg" mx="auto" px={2} py={4}>
        <Card elevation={3} sx={{ p: 3, borderRadius: 3 }}>
          <Grid container spacing={4} alignItems="center">
            
            {/* Product Image Gallery */}
            <Grid item xs={12} md={6}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <CardMedia
                  component="img"
                  image={selectedImage}
                  alt={product?.ProdName || "Loading..."}
                  sx={{ width: "100%", height: 400, objectFit: "contain", borderRadius: 2, mb: 2 }}
                />

                {product?.ProdImages || "" && product?.ProdImages || "".length > 1 && (
                  <Box display="flex" gap={1} overflow="auto">
                    {product?.ProdImages || "".map((img, index) => (
                      <CardMedia
                        key={index}
                        component="img"
                        image={img}
                        alt={`Thumbnail ${index + 1}`}
                        onClick={() => setSelectedImage(img)}
                        sx={{
                          width: 80,
                          height: 80,
                          objectFit: "cover",
                          borderRadius: 2,
                          cursor: "pointer",
                          border: selectedImage === img ? "2px solid blue" : "1px solid gray",
                        }}
                      />
                    ))}
                  </Box>
                )}
              </Box>
            </Grid>

            {/* Product Details */}
            <Grid item xs={12} md={6}>
              <Typography variant="h4" fontWeight="bold" gutterBottom>
              {product?.ProdName || "Loading..."}
              </Typography>

              {/* Price Section */}
              <Box display="flex" alignItems="center" gap={2} mb={2}>
              {product && product.ProdRetailPrice && (
  <Typography variant="h5" color="green">
    ₹{parseFloat(product.ProdRetailPrice).toFixed(2)}
  </Typography>
)}

{product?.ProductPercentage > 0 && (
  <>
    <Typography variant="body1" color="textSecondary" sx={{ textDecoration: "line-through" }}>
      ₹{parseFloat(product?.ProdMrpPrice).toFixed(2)}
    </Typography>
    <Typography variant="body2" sx={{ backgroundColor: "#FFEBEE", color: "#D32F2F", px: 1, py: 0.5, borderRadius: 1 }}>
      {product?.ProductPercentage}% off
    </Typography>
  </>
)}

              </Box>

              {/* Stock Information */}
              <Typography variant="body1" fontWeight="bold" color="textSecondary" mb={2}>
                Availability:{" "}
                <span style={{ color: isOutOfStock ? "red" : "green" }}>
                  {isOutOfStock ? "Out of stock" : `${product?.ProdStock || ""} in stock`}
                </span>
              </Typography>

              {/* Quantity Selector */}
              <Box display="flex" alignItems="center" gap={2} mb={4}>
                <Typography variant="body1" fontWeight="bold">Quantity:</Typography>
                <Box display="flex" alignItems="center" border={1} borderColor="divider" borderRadius={1}>
                  <IconButton onClick={() => handleQuantityChange(quantity - 1)} disabled={isOutOfStock || quantity === 1}>
                    <Remove />
                  </IconButton>
                  <Typography variant="body1" px={2}>{quantity}</Typography>
                  <IconButton onClick={() => handleQuantityChange(quantity + 1)} disabled={isOutOfStock || quantity === product?.ProdStock || ""}>
                    <Add />
                  </IconButton>
                </Box>
              </Box>

              {/* Action Buttons */}
              <Box display="flex" gap={2} flexDirection={{ xs: "column", sm: "row" }}>
                <Button variant="contained" color="primary" onClick={handleBuyNow} disabled={isOutOfStock} fullWidth sx={{ py: 1.5 }}>
                  Buy Now
                </Button>
                <Button variant="outlined" color="primary" onClick={handleAddToCart} disabled={isOutOfStock} fullWidth sx={{ py: 1.5 }}>
                  Add to Cart
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Box>

      <Footer />

      {/* Snackbar for Success Message */}
      <Snackbar open={successMessage} autoHideDuration={3000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: "100%" }}>
          Product added to cart successfully!
        </Alert>
      </Snackbar>


    </>
  );
};

export default ProductDetail;
